const defaultDays = 30
const sessionCache = {
  set(key, value) {
    if (!sessionStorage) {
      return
    }
    if (key != null && value != null) {
      sessionStorage.setItem(key, value)
    }
  },
  get(key) {
    if (!sessionStorage) {
      return null
    }
    if (key == null) {
      return null
    }
    return sessionStorage.getItem(key)
  },
  setJSON(key, jsonValue) {
    if (jsonValue != null) {
      this.set(key, JSON.stringify(jsonValue))
    }
  },
  getJSON(key) {
    const value = this.get(key)
    if (value != null) {
      return JSON.parse(value)
    }
  },
  remove(key) {
    sessionStorage.removeItem(key);
  }
}
const localCache = {
  set(key, value) {
    if (!localStorage) {
      return
    }
    if (key != null && value != null) {
      localStorage.setItem(key, value)
    }
  },
  get(key) {
    if (!localStorage) {
      return null
    }
    if (key == null) {
      return null
    }
    return localStorage.getItem(key)
  },
  setJSON(key, jsonValue) {
    if (jsonValue != null) {
      this.set(key, JSON.stringify(jsonValue))
    }
  },
  getJSON(key) {
    const value = this.get(key)
    if (value != null) {
      return JSON.parse(value)
    }
  },
  remove(key) {
    localStorage.removeItem(key);
  }
}

const cookieCache = {
  set(app, key, value, days) {
    const day = days || defaultDays
    if (key != null && value != null) {
      app.$cookies.set(key, value, { maxAge: day * 24 * 60 * 60, path: '/' })
    }
  },
  get(app, key) {
    if (key == null) {
      return null
    }

    var value = app.$cookies.get(key)
    if (value != null) {
      if (value === '') {
        return ''
      }
      return value;
    }

    return null

  },
  setJSON(app, key, jsonValue, days) {
    if (jsonValue != null) {
      app.$cookies.set(app, key, JSON.stringify(jsonValue), days)
    }
  },
  getJSON(app, key) {
    const value = app.$cookies.get(key)
    if (value != null) {
      return JSON.parse(value)
    }
  },
  remove(app, key, path = '/') {
    app.$cookies.remove(key, { path: path });
  }
}

export default {
  /**
   * 会话级缓存
   */
  session: sessionCache,
  /**
   * 本地缓存
   */
  local: localCache,
  /**
   * cookie缓存
   */
  cookie: cookieCache
}
